import {FormikErrors} from 'formik'
import {isEmpty} from 'lodash'
import {ChangeEvent} from 'react'
import FormInputMediaManager from 'src/cms/helpers/components/forms/FormInputMediaManager'
import FormSelect from 'src/cms/helpers/components/forms/FormSelect'
import FormTextBox from 'src/cms/helpers/components/forms/FormTextBox'
import FormTinyMce from 'src/cms/helpers/components/forms/FormTinyMce'
import {imageBaseUrl} from 'src/cms/helpers/constants'

interface Props {
  handleChange: (e: ChangeEvent<any>) => void
  errors: FormikErrors<{[key: string]: string}> | any
  touched: any
  values: {[key: string]: string} | any
  editSelectedData: {[key: string]: string}
  setFieldValue: any
}

export function SeoSocialComponent({
  handleChange,
  errors,
  touched,
  values,
  editSelectedData,
  setFieldValue,
}: Props) {
  return (
    <>
      <div className=''>
        <div className='row'>
          <div className='col-md-6 col-xs-12'>
            <FormTextBox
              type='text'
              placeholder='Enter Meta Title'
              name='metaTitle'
              label='Meta Title'
              labelClassName='col-md-12'
              containerClassName='col-md-12'
              onChange={handleChange}
              errors={errors}
              touched={touched}
            />
          </div>
          <div className='col-md-6 col-xs-12'>
            <FormTextBox
              type='text'
              placeholder='Enter Meta Title (NP)'
              name='metaTitleNp'
              label='Meta Title (NP)'
              labelClassName='col-md-12'
              containerClassName='col-md-12'
              onChange={handleChange}
              errors={errors}
              touched={touched}
            />
          </div>
          <div className='col-md-6 col-xs-12'>
            <FormTextBox
              type='text'
              placeholder='Enter Meta Keyword'
              name='metaKeyword'
              label='Meta Keyword'
              labelClassName='col-md-12'
              containerClassName='col-md-12'
              onChange={handleChange}
              errors={errors}
              touched={touched}
            />
          </div>
          <div className='col-md-6 col-xs-12'>
            <FormTinyMce
              containerClassName='col-md-12'
              label='Meta Description'
              name='metaDescription'
              initialValue={!isEmpty(editSelectedData) ? editSelectedData?.metaDescription : ''}
              handleChange={handleChange}
            />
          </div>
          <div className='col-md-6 col-xs-12'>
            <FormTinyMce
              containerClassName='col-md-12'
              label='Meta Description (NP)'
              name='metaDescriptionNp'
              initialValue={!isEmpty(editSelectedData) ? editSelectedData?.metaDescriptionNp : ''}
              handleChange={handleChange}
            />
          </div>

          <div className='col-md-6 col-xs-12'>
            <FormInputMediaManager
              labelClassName='col-md-12'
              containerClassName='col-md-12'
              label='OG Image (1200×630 for social sharing)'
              name='ogImage'
              setFieldValue={setFieldValue}
              value={values?.ogImage}
            />
            {!isEmpty(values?.ogImage) && (
              <li className='listing'>
                <div className='thumbImageBlock'>
                  <button
                    type='button'
                    title='Remove'
                    className='btn thumbImage-remove d-flex align-items-center justify-content-center btn-primary'
                    onClick={() => setFieldValue('ogImage', '')}
                    data-cy='modal-thumbnail-remove'
                  >
                    Delete
                  </button>
                  <img
                    className='thumbImage w-100 h-100'
                    src={`${imageBaseUrl}/${values?.ogImage}`}
                    alt=''
                  />
                </div>
              </li>
            )}
          </div>

          <div className='col-md-6 col-xs-12'>
            <FormTextBox
              type='text'
              placeholder='Enter OG Title'
              name='ogTitle'
              label='OG Title (social override, optional)'
              labelClassName='col-md-12'
              containerClassName='col-md-12'
              onChange={handleChange}
              errors={errors}
              touched={touched}
            />
          </div>

          <div className='col-md-6 col-xs-12'>
            <FormTextBox
              type='text'
              placeholder='Leave blank for auto'
              name='canonicalUrl'
              label='Canonical URL'
              labelClassName='col-md-12'
              containerClassName='col-md-12'
              onChange={handleChange}
              errors={errors}
              touched={touched}
            />
          </div>

          <div className='col-md-6 col-xs-12'>
            <FormSelect
              labelClassName='col-md-12'
              containerClassName='col-md-12'
              label='Robots'
              name='robots'
              placeholder='Select robots directive'
              onChange={handleChange}
              errors={errors}
              touched={touched}
              values={values}
              setFieldValue={setFieldValue}
              options={[
                {label: 'index, follow (default)', value: 'index, follow'},
                {label: 'noindex, nofollow', value: 'noindex, nofollow'},
                {label: 'noindex, follow', value: 'noindex, follow'},
                {label: 'noindex', value: 'noindex'},
              ]}
            />
          </div>

          <div className='col-md-12 col-xs-12'>
            <FormTextBox
              type='text'
              as='textarea'
              rows={8}
              placeholder='{"@type": "Product", ...}'
              name='structuredData'
              label='Structured Data (JSON-LD, advanced — leave blank to use the auto-generated schema)'
              labelClassName='col-md-12'
              containerClassName='col-md-12'
              onChange={handleChange}
              errors={errors}
              touched={touched}
            />
          </div>
        </div>
      </div>
    </>
  )
}
